<template>
  <div class="clinicCouponModal">
    <el-form ref="form">
      <el-form-item>
        <div class="import_csv">
          <input id="customers_csv_file" class="inputfile"/>
          <label for="customers_csv_file">
            <figure @click="selectFile">
              <svg class="icon-import_cp" height="17" viewBox="0 0 20 17" width="20" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"></path>
              </svg>
            </figure>
            <span class="#customer-import-csv-file-name text-black">{{ this.fileName }}</span>
          </label>
        </div>
        <input type="file" id="file" ref="file" accept=".csv" style="display:none" @change="handleFileUpload( $event )">
      </el-form-item>
      <div class="text-center group-btn-import">
        <el-button class="btn-import-coupon" type="success" @click="submitFile" :disabled=" this.fileName === '' ">
          アップロードする
        </el-button>
      </div>
    </el-form>

  </div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  data() {
    return {
      file: '',
      fileName: ''
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    ...mapMutations('clinic_coupon', ['SET_CSV_VISIBLE', 'SET_CSV_NAME_FILE']),
    ...mapActions('clinic_coupon', ['importCsvCoupon']),
    selectFile() {
      let fileInputElement = this.$refs.file
      fileInputElement.click()
    },
    submitFile() {
      this.importCsvCoupon(this.file)
    },
    handleFileUpload(event) {
      this.file = event.target.files[0]
      this.fileName = this.file.name
    }
  }
}
</script>
<style scoped>
.btn-clinic-coupon {
  width: 85px;
}
</style>
